/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { DataPageOfPayers } from '../models/data-page-of-payers';
import { DataPageWithColumnsOfFinancial } from '../models/data-page-with-columns-of-financial';
import { Financial } from '../models/financial';
import { financialEncounterNoteDetail } from '../fn/financial/financial-encounter-note-detail';
import { FinancialEncounterNoteDetail$Params } from '../fn/financial/financial-encounter-note-detail';
import { financialGetAllPayers } from '../fn/financial/financial-get-all-payers';
import { FinancialGetAllPayers$Params } from '../fn/financial/financial-get-all-payers';
import { financialGetFinacialList } from '../fn/financial/financial-get-finacial-list';
import { FinancialGetFinacialList$Params } from '../fn/financial/financial-get-finacial-list';
import { financialGetInsuranceList } from '../fn/financial/financial-get-insurance-list';
import { FinancialGetInsuranceList$Params } from '../fn/financial/financial-get-insurance-list';
import { financialInsuranceDetail } from '../fn/financial/financial-insurance-detail';
import { FinancialInsuranceDetail$Params } from '../fn/financial/financial-insurance-detail';
import { financialInsuranceImageDataDetails } from '../fn/financial/financial-insurance-image-data-details';
import { FinancialInsuranceImageDataDetails$Params } from '../fn/financial/financial-insurance-image-data-details';
import { financialTransactionDetail } from '../fn/financial/financial-transaction-detail';
import { FinancialTransactionDetail$Params } from '../fn/financial/financial-transaction-detail';
import { financialUpdatePayers } from '../fn/financial/financial-update-payers';
import { FinancialUpdatePayers$Params } from '../fn/financial/financial-update-payers';

@Injectable({ providedIn: 'root' })
export class FinancialService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `financialGetFinacialList()` */
  static readonly FinancialGetFinacialListPath = '/financial/summarylist';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `financialGetFinacialList()` instead.
   *
   * This method doesn't expect any request body.
   */
  financialGetFinacialList$Response(params?: FinancialGetFinacialList$Params, context?: HttpContext): Observable<StrictHttpResponse<DataPageWithColumnsOfFinancial>> {
    return financialGetFinacialList(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `financialGetFinacialList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  financialGetFinacialList(params?: FinancialGetFinacialList$Params, context?: HttpContext): Observable<DataPageWithColumnsOfFinancial> {
    return this.financialGetFinacialList$Response(params, context).pipe(
      map((r: StrictHttpResponse<DataPageWithColumnsOfFinancial>): DataPageWithColumnsOfFinancial => r.body)
    );
  }

  /** Path part for operation `financialGetInsuranceList()` */
  static readonly FinancialGetInsuranceListPath = '/financial/insurancelist';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `financialGetInsuranceList()` instead.
   *
   * This method doesn't expect any request body.
   */
  financialGetInsuranceList$Response(params?: FinancialGetInsuranceList$Params, context?: HttpContext): Observable<StrictHttpResponse<Financial>> {
    return financialGetInsuranceList(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `financialGetInsuranceList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  financialGetInsuranceList(params?: FinancialGetInsuranceList$Params, context?: HttpContext): Observable<Financial> {
    return this.financialGetInsuranceList$Response(params, context).pipe(
      map((r: StrictHttpResponse<Financial>): Financial => r.body)
    );
  }

  /** Path part for operation `financialEncounterNoteDetail()` */
  static readonly FinancialEncounterNoteDetailPath = '/financial/encounterNoteDetail';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `financialEncounterNoteDetail()` instead.
   *
   * This method doesn't expect any request body.
   */
  financialEncounterNoteDetail$Response(params?: FinancialEncounterNoteDetail$Params, context?: HttpContext): Observable<StrictHttpResponse<Financial>> {
    return financialEncounterNoteDetail(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `financialEncounterNoteDetail$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  financialEncounterNoteDetail(params?: FinancialEncounterNoteDetail$Params, context?: HttpContext): Observable<Financial> {
    return this.financialEncounterNoteDetail$Response(params, context).pipe(
      map((r: StrictHttpResponse<Financial>): Financial => r.body)
    );
  }

  /** Path part for operation `financialTransactionDetail()` */
  static readonly FinancialTransactionDetailPath = '/financial/transactionDetail';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `financialTransactionDetail()` instead.
   *
   * This method doesn't expect any request body.
   */
  financialTransactionDetail$Response(params?: FinancialTransactionDetail$Params, context?: HttpContext): Observable<StrictHttpResponse<Financial>> {
    return financialTransactionDetail(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `financialTransactionDetail$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  financialTransactionDetail(params?: FinancialTransactionDetail$Params, context?: HttpContext): Observable<Financial> {
    return this.financialTransactionDetail$Response(params, context).pipe(
      map((r: StrictHttpResponse<Financial>): Financial => r.body)
    );
  }

  /** Path part for operation `financialInsuranceDetail()` */
  static readonly FinancialInsuranceDetailPath = '/financial/insurancedetails';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `financialInsuranceDetail()` instead.
   *
   * This method doesn't expect any request body.
   */
  financialInsuranceDetail$Response(params?: FinancialInsuranceDetail$Params, context?: HttpContext): Observable<StrictHttpResponse<Financial>> {
    return financialInsuranceDetail(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `financialInsuranceDetail$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  financialInsuranceDetail(params?: FinancialInsuranceDetail$Params, context?: HttpContext): Observable<Financial> {
    return this.financialInsuranceDetail$Response(params, context).pipe(
      map((r: StrictHttpResponse<Financial>): Financial => r.body)
    );
  }

  /** Path part for operation `financialInsuranceImageDataDetails()` */
  static readonly FinancialInsuranceImageDataDetailsPath = '/financial/insuranceImageDataDetails';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `financialInsuranceImageDataDetails()` instead.
   *
   * This method doesn't expect any request body.
   */
  financialInsuranceImageDataDetails$Response(params?: FinancialInsuranceImageDataDetails$Params, context?: HttpContext): Observable<StrictHttpResponse<Financial>> {
    return financialInsuranceImageDataDetails(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `financialInsuranceImageDataDetails$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  financialInsuranceImageDataDetails(params?: FinancialInsuranceImageDataDetails$Params, context?: HttpContext): Observable<Financial> {
    return this.financialInsuranceImageDataDetails$Response(params, context).pipe(
      map((r: StrictHttpResponse<Financial>): Financial => r.body)
    );
  }

  /** Path part for operation `financialGetAllPayers()` */
  static readonly FinancialGetAllPayersPath = '/financial/getPayers';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `financialGetAllPayers()` instead.
   *
   * This method doesn't expect any request body.
   */
  financialGetAllPayers$Response(params?: FinancialGetAllPayers$Params, context?: HttpContext): Observable<StrictHttpResponse<DataPageOfPayers>> {
    return financialGetAllPayers(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `financialGetAllPayers$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  financialGetAllPayers(params?: FinancialGetAllPayers$Params, context?: HttpContext): Observable<DataPageOfPayers> {
    return this.financialGetAllPayers$Response(params, context).pipe(
      map((r: StrictHttpResponse<DataPageOfPayers>): DataPageOfPayers => r.body)
    );
  }

  /** Path part for operation `financialUpdatePayers()` */
  static readonly FinancialUpdatePayersPath = '/financial/updatePayers';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `financialUpdatePayers()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  financialUpdatePayers$Response(params: FinancialUpdatePayers$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return financialUpdatePayers(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `financialUpdatePayers$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  financialUpdatePayers(params: FinancialUpdatePayers$Params, context?: HttpContext): Observable<Blob> {
    return this.financialUpdatePayers$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

}
